import { Check, Edit } from "@material-ui/icons";
import { IconButton, TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import { otherStyles } from "../../../../app/helpers/utils";
import styled from "styled-components";

export default function TableHeader() {
  const otherClasses = otherStyles();
  const {
    seqCohortColumnHeaders,
    setSeqCohortColumnHeaders,
    setSeqCohortChangeLog,
    seqCohorts,
    setSeqCohorts,
  } = useStudyPlan();
  const [columnHeaderEdit, setColumnHeaderEdit] = useState({});
  const [originalHeaderValues, setOriginalHeaderValues] = useState({});

  const renderEditableColumnHeader = (name) => {
    return (
      <Cell
        width={`${(9 / 70) * 100}%`}
        variant="header"
      >
        {!columnHeaderEdit[name] && (
          <Typography
            style={{ 
              flex: 1, 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap' 
            }}
            variant="body1"
          >
            <strong>{seqCohortColumnHeaders[name]}</strong>
          </Typography>
        )}
        {columnHeaderEdit[name] && (
          <TextField
            style={{ flex: 1 }}
            value={seqCohortColumnHeaders[name]}
            onChange={(e) => {
              setSeqCohortColumnHeaders({
                ...seqCohortColumnHeaders,
                [name]: e.target.value,
              });
              setSeqCohortChangeLog({ someValue: "seq cohort change" });
            }}
            variant="outlined"
            size="small"
            inputProps={{ maxLength: 50 }}
          />
        )}

        {
          <EditButtonContainer>
            <IconButton
              disableRipple
              className={otherClasses.iconButton}
              size="small"
              onClick={() => {
                const isCurrentlyEditing = columnHeaderEdit[name];
                if (!isCurrentlyEditing) {
                  // Starting edit - store original value
                  setOriginalHeaderValues((prev) => ({
                    ...prev,
                    [name]: seqCohortColumnHeaders[name],
                  }));
                } else {
                  // Confirming edit - update ALL cohort rows that reference the old value
                  const oldValue = originalHeaderValues[name];
                  const newValue = seqCohortColumnHeaders[name];
                  if (oldValue && oldValue !== newValue) {
                    const updatedCohorts = seqCohorts.map((cohort) => {
                      if (cohort.predecessorActivity === oldValue) {
                        return {
                          ...cohort,
                          [name]: newValue,
                          predecessorActivity: newValue,
                        };
                      }
                      return cohort;
                    });
                    setSeqCohorts(updatedCohorts);
                    setSeqCohortChangeLog({ someValue: "seq cohort change" });
                  }
                }
                
                setColumnHeaderEdit({
                  ...columnHeaderEdit,
                  [name]: !columnHeaderEdit[name],
                });
              }}
            >
              {!columnHeaderEdit[name] ? <Edit /> : <Check />}
            </IconButton>
          </EditButtonContainer>
        }
      </Cell>
    );
  };
  return (
    <>
      <Row>
        <Space width={`${(8 / 70) * 100}%`} />
        <Space width={`${(8 / 70) * 100}%`} />
        <Space width={`${(4 / 70) * 100}%`} />
        <Space width={`${(5 / 70) * 100}%`} />
        <Space
          width={`${(3 / 70) * 100}%`}
          rightBorderColor={"var(--surface-300)"}
        />
        <Cell
          width={`${(6 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Cohort Start</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(9 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Screening</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(9 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Enrolling</strong>
          </Typography>
        </Cell>
        {renderEditableColumnHeader("columnHeader3")}
        {renderEditableColumnHeader("columnHeader4")}
      </Row>
      <Row>
        <Cell
          width={`${(8 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Cohort Name</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(8 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Predecessor Cohort</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(4 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Predecessor Activity</strong>
          </Typography>{" "}
        </Cell>
        <Cell
          width={`${(5 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Enrolled Participants</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(3 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Lag</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(6 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Start Date</strong>
          </Typography>
        </Cell>
        {/* <Cell width={`${(2 / 70) * 100}%`} variant="header">
          <Typography variant="body1">
            <strong>Study Day</strong>
          </Typography>
        </Cell> */}
        <Cell
          width={`${(4 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Duration</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(5 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>End Date</strong>
          </Typography>
        </Cell>
        {/* <Cell width={`${(2 / 70) * 100}%`} variant="header">
          <Typography variant="body1">
            <strong>Study Day</strong>
          </Typography>
        </Cell> */}
        <Cell
          width={`${(4 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Duration</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(5 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>End Date</strong>
          </Typography>
        </Cell>
        {/* <Cell width={`${(2 / 70) * 100}%`} variant="header">
          <Typography variant="body1">
            <strong>Study Day</strong>
          </Typography>
        </Cell> */}
        <Cell
          width={`${(4 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Duration</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(5 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>End Date</strong>
          </Typography>
        </Cell>
        {/* <Cell width={`${(2 / 70) * 100}%`} variant="header">
          <Typography variant="body1">
            <strong>Study Day</strong>
          </Typography>
        </Cell> */}
        <Cell
          width={`${(4 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>Duration</strong>
          </Typography>
        </Cell>
        <Cell
          width={`${(5 / 70) * 100}%`}
          variant="header"
        >
          <Typography variant="body1">
            <strong>End Date</strong>
          </Typography>
        </Cell>
        {/* <Cell width={`${(2 / 70) * 100}%`} variant="header">
          <Typography variant="body1">
            <strong>Study Day</strong>
          </Typography>
        </Cell> */}
      </Row>
    </>
  );
}

const Row = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  height: 50px;
  border-bottom: ${(p) =>
    p.noBorder ? "none" : "1px solid var(--surface-300)"};
  &:last-child {
    border: none;
  }
`;

const Cell = styled.div`
  background: ${(p) =>
    p.variant === "header" ? "var(--surface-50)" : "var(--White)"};
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  width: ${(p) => (p.width ? p.width : "100%")};
  border-right: 1px solid var(--surface-300);
  padding: 5px;
  text-align: center;
  border-left: ${(p) =>
    p.leftBorder ? "1px solid var(--surface-300)" : "none"};
  &:last-child {
    border: ${(p) => (p.rightBorder ? "1px solid var(--surface-300)" : "none")};
  }
  border: ${(p) => (p.fullBorder ? "1px solid var(--surface-300)" : "")};
`;

const Space = styled.div`
  height: 100%;
  width: ${(p) => (p.width ? p.width : "100%")};
  border-right: 1px solid ${(p) => p.rightBorderColor || "transparent"};
  padding: 5px;
  text-align: center;
  border-left: ${(p) => (p.leftBorder ? "1px solid transparent" : "none")};
  &:last-child {
    border: none;
  }
`;

const EditButtonContainer = styled.div`
  cursor: pointer;
  padding: 1px;
  border-radius: 50%;
`;
